import type { ComponentProps } from 'react';

type OfferMainContentProps = Omit<ComponentProps<'div'>, 'id' | 'role' | 'aria-label' | 'tabIndex'>;

/**
 * Wrapper component for the main content of an offer.
 * It adds the necessary attributes to the div element to make it accessible and drives consistency across the apps.
 * @param props - The props of div element for the component.
 * @returns The HTML div element with the necessary attributes.
 */
function OfferMainContent(props: OfferMainContentProps) {
  return <div id="main-content" role="main" aria-label="Main content" tabIndex={-1} {...props} />;
}

export { OfferMainContent };
